// extracted by mini-css-extract-plugin
export default {"opener":"opener--smv5F","popoverContainer":"popoverContainer--_eWKZ","frontArrow":"frontArrow--lyO1w","backArrow":"backArrow--fszvJ"};